import { all, takeEvery, put, call } from 'redux-saga/effects';
import applicantActions from './actions';
import { tableConfig } from '../../../settings/index';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import Api from '../../../helpers/api';

const api = new Api('applicants');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = payload;
    let { district = [] } = payload;

    if (!Array.isArray(district)) {
      district = [district];
    }

    const result = yield call(
      sendRequest,
      api.load,
      { search: { ...payload, page, pageSize, column, order, filter, district } },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      const { records, totalCount, filteredCount, sortable_columns, actions, filters, saved_searches } = result.data;

      yield put(
        applicantActions.loadDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
          actions,
          filters,
          savedSearches: saved_searches,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(applicantActions.LOAD, loadData)]);
}
